module.exports = __webpack_public_path__ + "img/image-8.f7bd71c2.jpg";